import { Base } from './base';

export class QuestionType extends Base {
	protected data = [
    {
      name: 'error',
      japanese: 'エラー',
      typeVal: -1,
    },
    {
      name: "essay",
      japanese: '記述',
      typeVal: 1,
    },
    {
      name: 'selection',
      japanese: '選択',
      typeVal: 2,
    },
    {
      name: 'hide',
      japanese: '非表示',
      typeVal: 3,
    }
  ];

  public showJapanese(typeVal: number): string | Error {
    let result :any = this._throwErrorNotFound();
    
    this.data.map((value, index) => {
      if (value.typeVal == typeVal) {
        result = value.japanese;
      }
    });

    return result;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/questionType.ts